/* eslint-disable no-undef */
//3rd Party Components
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import queryString from 'query-string';
import * as msal from '@azure/msal-browser';
import AUpageAlert from '@gov.au/page-alerts';
import MetaTags from 'react-meta-tags';

//Styles
import '../src/styles/bootstrap.css';
import '../src/styles/audesign.css';
import '../src/styles/footer.css';
import '../src/styles/CASA.css';
import '../src/styles/webfonststyle112.css';

import './styles/CASAForm.css';

//Standard Components
import Header from '../src/components/CASA/Header';
import CasaFooter from '../src/components/CASA/Footer';
import ProcessMessage from '../src/components/Portal/ProcessMessage';

//Pages
import { HomePage } from '../src/pages/HomePage';

import { SimpleVerificationPage } from '../src/pages/VerificationPage/SimpleVerificationPage';
import DigitalLicenceVerification from '../src/forms/DigitalLicenceVerification';

//Actions
import { getB2CSettings } from '../src/components/Portal/Utilities';
import { addB2CSettings } from '../src/PortalStore/Actions/B2CSettingsActions';

import rootReducer from '../src/PortalStore/Reducers/rootReducer';

//logging
import logger from 'redux-logger';

//Start
const rootElement = document.getElementById('root');

var portalStore;

let webappurlFormsApi = '';
let webappurlPortalApi = '';
let webappurlDigLicApi = '';

setupAppUrl();

let urlParams = queryString.parse(window.location.search);
let urlParamsH = queryString.parse(window.location.hash);

let parsed = '';
let standalone = false;
var msalInstance = new Object();

setupParams();

if ((standalone)
    || (window.location.pathname !== '/forms')
    || (urlParamsH.client_info !== undefined)) {
    //setup store
    if (process.env.NODE_ENV !== 'development') {
        portalStore = createStore(rootReducer, compose(
            applyMiddleware(thunk)
        ));
    } else {
        //only if localhost
        if (window.__REDUX_DEVTOOLS_EXTENSION__) {
            portalStore = createStore(rootReducer, compose(
                applyMiddleware(thunk),
                window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true, traceLimit: 25 })
            ));
        }
        else {
            portalStore = createStore(rootReducer, compose(
                applyMiddleware(thunk, logger)
            ));
        }
    }

    var B2CSettings = {};

    //Get B2CSettings
    axios.all([
        getB2CSettings(webappurlPortalApi)
    ])
        .then(responseArr => {
            if (responseArr[0].status === 200) {
                setupB2CSettings(responseArr);
                if (window.location.pathname === '/forms/signedout') {
                    loggedOut(portalStore);
                }
                else {
                    const msalconfig2 = ConfigureMsalConfig();
                    msalInstance = new msal.PublicClientApplication(msalconfig2);
     
                    msalInstance.handleRedirectPromise()
                        .then(handleResponse).catch(() => {
                            showError('INIT.1b', portalStore);
                        });
                }
            }
            else {
                showError('INIT.1', portalStore);
            }
        })
        .catch(() => {
            showError('INIT.1a', portalStore);
        });
}
else {
    showWaiting();
}

function showWaiting() {
    portalStore = createStore(rootReducer, compose());

    ReactDOM.render(
        <Provider store={portalStore}>
            <main className='body au-body' role='main'>

                <div className='au-grid'>

                    <Header />

                    <div>CASA Portal - waiting for customers</div>

                    <CasaFooter />

                </div>
            </main>
        </Provider>,

        rootElement
    );
}

function loggedOut(portalStore) {
    ReactDOM.render(
        <BrowserRouter basename='/forms' >
            <Provider store={portalStore}>
                <main className='au-grid' role='main'>

                    <Header />

                    <MetaTags>
                        <title>Signed Out</title>
                    </MetaTags>

                    <ProcessMessage />

                    <div className='au-form-group body container'>

                        <a className='au-btn' href='/forms?standalone=true'>
                            Sign in
                        </a>

                    </div>

                    <CasaFooter />

                </main>
            </Provider>
        </BrowserRouter>,
        rootElement
    );
}

function showSimpleVerification(portalStore) {
    ReactDOM.render(
        <BrowserRouter basename='/forms'>
            <Provider store={portalStore}>
                <main className='au-grid' role='main'>

                    <Header />

                    <MetaTags title='Licence Verification'></MetaTags>

                    <SimpleVerificationPage />

                    <CasaFooter />
                </main>
            </Provider>
        </BrowserRouter>,
        rootElement
    );
}

function showLicenceVerification(portalStore) {
    ReactDOM.render(
        <BrowserRouter basename='/forms'>
            <Provider store={portalStore}>
                <main className='au-grid' role='main'>

                    <Header />

                    <MetaTags title='Licence Verification'></MetaTags>

                    <DigitalLicenceVerification />

                    <CasaFooter />
                </main>
            </Provider>
        </BrowserRouter>,
        rootElement
    );
}

function showError(message, portalStore) {

    //store used by header and footer
    ReactDOM.render(

        <Provider store={portalStore}>
            <main className='body au-body' role='main'>

                <div className='au-grid'>

                    <Header />

                    <AUpageAlert as='error'>
                        <div id='systemError' aria-live='polite'>
                            <br />
                            <h3>We&apos;re sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.</h3>
                            <p>Details: System error (Code: {message})</p>
                            <br />
                        </div>
                    </AUpageAlert>

                    <CasaFooter />

                </div>
            </main>
        </Provider>
        ,
        rootElement
    );
}

function setupAppUrl() {
    webappurlFormsApi = webappurlPortalApi = '';
    //LOCAL
    if (window.location.origin === 'https://localhost:44336' || window.location.origin === 'https://localhost:44337') {
        //standalone = true;
        webappurlFormsApi = 'https://localhost:44372';
        //webappurlFormsApi = 'https://mycasa-formsapi-webapi-casa-sdtd2-01-aes.azurewebsites.net'
        //webappurlFormsApi = 'https://mycasa-formsapi-webapi-casa-sdtuat-01-aes.azurewebsites.net'
        //webappurlPortalApi = 'https://mycasa-portalapi-webapi-casa-sdtd2-01-aes.azurewebsites.net'
        //webappurlPortalApi = 'https://mycasa-portalapi-webapi-casa-sdtd2-01-aes.azurewebsites.net'
        webappurlPortalApi = 'https://mycasa-portalapi-webapi-casa-sdtuat-01-aes.azurewebsites.net'
        //webappurlPortalApi = 'https://mycasa-portalapi-webapi-casa-preprd-01-aes.azurewebsites.net'
        //webappurlPortalApi = 'https://localhost:44320';
        webappurlDigLicApi = 'https://localhost:44315';
    }
}

function setupParams() {
    if (urlParams.standalone !== undefined && urlParams.standalone === 'true') {
        standalone = true;
    }

    if (urlParams !== undefined && urlParams.params !== undefined) {
        var params = atob(decodeURIComponent(urlParams.params));
        parsed = JSON.parse(params);
    }
}

function setupB2CSettings(responseArr) {
    B2CSettings = responseArr[0].data;
    B2CSettings.webappurlFormsApi = webappurlFormsApi;
    B2CSettings.webappurlPortalApi = webappurlPortalApi;
    B2CSettings.DigitalLicenceAPIUrl = webappurlDigLicApi;
    B2CSettings.standalone = standalone;
    B2CSettings.parsed = parsed;
}

//msal2
function ConfigureMsalConfig() {
    // to fix the payment redirect following QG code implementation has been commented out, 
    // let redirect = '';
    // if (window.location.pathname == '/forms/digitallicence/verification/submit') {
    //     redirect = window.location.origin + window.location.pathname;
    // }
    // else {
    //     redirect = window.location.origin + '/forms';
    // }
    // console.log('redirect:' + redirect);
    var mc = {
        auth: {
            clientId: B2CSettings.AuthClientId,
            authority: B2CSettings.SignUpAuthority,
            knownAuthorities: [B2CSettings.AuthAuthority],
            redirectUri: window.location.origin + window.location.pathname
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false
        }
    };
    return mc;
}

var username = '';

function handleResponse(response) {

    const msal2LoginPortalRequest = {
        scopes: ['openid'],
        extraScopesToConsent: [B2CSettings.ScopesPortal]
    };

    try {
        if (response !== null) {
            username = response.account.username;
        } else {
            const currentAccounts = msalInstance.getAllAccounts();
            if (!currentAccounts || currentAccounts.length < 1) {
                msalInstance.loginRedirect(msal2LoginPortalRequest);
            } else if (currentAccounts.length > 1) {
                //Multiple accounts detected.
                showError('INIT.1e', portalStore);
            } else if (currentAccounts.length === 1) {
                username = currentAccounts[0].username;
            }
        }
    }
    catch {
        showError('INIT.1f', portalStore);
    }

    AquireAccessTokens();
}

function AquireAccessTokens() {

    const msal2LoginFormsRequest = {
        scopes: ['openid'],
        extraScopesToConsent: [B2CSettings.ScopesForms]
    };

    if (username.length > 0) {

        let tokenPortalRequest = {
            scopes: [B2CSettings.ScopesPortal],
            account: msalInstance.getAccountByUsername(username)
        };

        let tokenFormsRequest = {
            scopes: [B2CSettings.ScopesForms],
            account: msalInstance.getAccountByUsername(username)
        };

        msalInstance.acquireTokenSilent(tokenPortalRequest)
            .then(tokenResponse1 => {
                B2CSettings.accesstokenPortal = tokenResponse1.accessToken;
                msalInstance.acquireTokenSilent(tokenFormsRequest)
                    .then(tokenResponse2 => {
                        if (tokenResponse2.accessToken == '') {
                            msalInstance.loginRedirect(msal2LoginFormsRequest);
                        }
                        else {
                            B2CSettings.accesstokenForms = tokenResponse2.accessToken;
                            const token = JSON.parse(atob(tokenResponse2.accessToken.split('.')[1]));
                            B2CSettings.loginPath = token.authenticationSource == 'socialIdpAuthentication' ? 'myGov' : 'myCasa';
                            if (token.authenticationSource == 'socialIdpAuthentication') {
                                const {given_name, family_name, dateofBirth, emails} = token;
                                B2CSettings.myGovUser = {given_name, family_name, dateOfBirth: dateofBirth, emails};
                            }
                            axios.all([
                                portalStore.dispatch(addB2CSettings(B2CSettings))
                            ])
                                .then(() => {
                                    ReactDOM.render(
                                        <BrowserRouter basename='/forms'>
                                            <Provider store={portalStore}>
                                                <HomePage />
                                            </Provider>
                                        </BrowserRouter>,
                                        rootElement
                                    );
                                })
                        }

                    });
            })
            .catch(async () => {
                //silent token acquisition failed.
                showError('INIT.1d', portalStore);
            });
    }
}
